import React, { useEffect } from 'react';

import { Table } from 'antd';
import moment from 'moment/moment';
import queryString from 'query-string';

import { formatNumber2, getLastQtrByIdx, green } from '../../utils';
import { getReportStyles } from './SearchReport.helper';
import styles from './style.module.scss';

const VolTable = ({
  searchData,
  reportSubType,
  queryData,
  reportType,
  isLoading,
  onTableChange,
  sortDetail,
  y,
  history,
  visibleColumnsData,
}) => {
  const rows = [];

  searchData.forEach((stockArray, stockIndex) => {
    const rowData = Object.fromEntries(
      stockArray.map((item) => [item.key, item.value]),
    );

    const symbol = rowData['symbol'];
    const numWeeks = parseInt(rowData['no_of_weeks_increased']) || 0;

    let beginPrice;
    let endPrice;
    let latestPeriodChange = 0;
    let latestPeriodReturns = 0;
    let earningsDate = '';
    let noOfWeeksLatest = 0;
    let noOfWeeksInPast = '';
    let startPrice;
    const extractAndFormatDate = (inputString) => {
      const dateStr = inputString.split('(')[0].trim();
      const date = moment(dateStr);
      return date.format('DD MMM YYYY');
    };
    // const extractPrice = (priceString) => {
    //   const match = priceString.match(/\$(\d+(\.\d+)?)/); // Match the price value with the $ sign
    //   return match ? parseFloat(match[1]) : 0;
    // };
    // Iterate through the weeks and calculate the required data
    if (numWeeks > 1) {
      // Week 1 data (for ending date and price)
      const week1Data = rowData['week_1'];
      const [week1AvgVol, , week1Date] = week1Data.split(',');
      console.log(week1AvgVol, week1Date);
      endPrice = `${week1AvgVol}`; // End Price (from week_1)

      // Get the "week_{no_of_weeks_increased}" for the start date and price
      const weekNData = rowData[`week_${numWeeks + 1}`];
      const [weekNAvgVol, weekNPrice, , startPriceValue] = weekNData.split(',');
      startPrice = (startPriceValue / 100).toFixed(2);
      console.log(weekNAvgVol, weekNPrice);
      beginPrice = `${weekNAvgVol}`; // Begin Price (from week_${numWeeks})

      const beginPriceValue = weekNAvgVol;
      const endPriceValue = week1AvgVol;
      beginPrice = (
        <>
          <div>{beginPriceValue}</div>
          <div>({extractAndFormatDate(weekNPrice)})</div>
        </>
      );

      endPrice = (
        <>
          <div>{endPriceValue}</div>
          <div>({extractAndFormatDate(week1Date)})</div>
        </>
      );

      // Calculating the Latest Period Change and Latest Period Returns
      latestPeriodChange = endPriceValue - beginPriceValue;
      latestPeriodReturns = (
        (latestPeriodChange / beginPriceValue) *
        100
      ).toFixed(2);

      // Assigning the No. of Weeks Latest and No. of Weeks In The Past
      noOfWeeksLatest = rowData['no_of_weeks_increased'] || 0;

      // Example for earnings date and no of weeks in past (assuming data follows the same pattern)
      earningsDate = rowData['earningsDate'] || 'N/A'; // Replace with actual data
      noOfWeeksInPast = rowData['no_of_weeks_past'] || 'N/A'; // Replace with actual data
    } else if (numWeeks === 1) {
      // Week 1 data (for ending date and price)
      const week1Data = rowData['week_1'];
      const [week1AvgVol, , week1Price] = week1Data.split(',');
      console.log(week1AvgVol, week1Price);
      endPrice = `${week1AvgVol}`; // End Price (from week_1)

      // Get the "week_{no_of_weeks_increased}" for the start date and price
      const weekNData = rowData[`week_${numWeeks + 1}`];
      const [weekNAvgVol, weekNPrice, , startPriceValue] = weekNData.split(',');
      console.log(weekNAvgVol, weekNPrice);
      startPrice = (startPriceValue / 100).toFixed(2);
      beginPrice = `${weekNAvgVol}`; // Begin Price (from week_${numWeeks})

      const beginPriceValue = weekNAvgVol;
      const endPriceValue = week1AvgVol;
      beginPrice = (
        <>
          <div>{beginPriceValue}</div>
          <div>({extractAndFormatDate(weekNPrice)})</div>
        </>
      );

      endPrice = (
        <>
          <div>{endPriceValue}</div>
          <div>({extractAndFormatDate(week1Price)})</div>
        </>
      );

      // Calculating the Latest Period Change and Latest Period Returns
      latestPeriodChange = endPriceValue - beginPriceValue;
      latestPeriodReturns = (
        (latestPeriodChange / beginPriceValue) *
        100
      ).toFixed(2);

      // Assigning the No. of Weeks Latest and No. of Weeks In The Past
      noOfWeeksLatest = rowData['no_of_weeks_increased'] || 0;

      // Example for earnings date and no of weeks in past (assuming data follows the same pattern)
      earningsDate = rowData['earningsDate'] || 'N/A'; // Replace with actual data
      noOfWeeksInPast = rowData['no_of_weeks_past'] || 'N/A'; // Replace with actual data
    }
    const latestPricePercDiff =
      ((rowData['lastSale'] - startPrice) / startPrice) * 100;

    rows.push({
      key: stockIndex,
      symbol,
      sec13dCount: rowData['sec13dCount'] ? rowData['sec13dCount'] : 0,
      sector: rowData['sector'],
      beginPrice,
      startPrice: `$${startPrice}`,
      lastSale: `$${rowData['lastSale']}`,
      endPrice,
      latestPeriodChange: `${latestPeriodChange}`,
      latestPeriodReturns: `${latestPeriodReturns}%`,
      latestPercPrice: `${latestPricePercDiff.toFixed(2)}%`,
      year_start_price: `$${rowData['year_start_price']}`,
      ytd: `${rowData['ytd']}%`,
      fiveYrGrowth: rowData['fiveYrGrowth']
        ? `${rowData['fiveYrGrowth']}%`
        : '-',
      latest_returns_perc: rowData['latest_returns_perc'],
      ytd_increased: rowData['ytd_increased'],
      ytd_past_increased: rowData['ytd_past_increased'],
      oneYrGrowth: rowData['oneYrGrowth'] ? `${rowData['oneYrGrowth']}%` : '-',
      noOfWeeksLatest,
      earningsDate,
      no_of_weeks_past: noOfWeeksInPast,

      lastQtr1Shares: formatNumber2(rowData['lastQtr1Shares']),
      lastQtr2Shares: formatNumber2(rowData['lastQtr2Shares']),
      lastQtrSharesChange: rowData['lastQtrSharesChange'],
      lastQtr1Count: formatNumber2(rowData['lastQtr1Count']),
      lastQtr2Count: formatNumber2(rowData['lastQtr2Count']),
      lastQtrCountChange: rowData['lastQtrCountChange'],
      lastQtr1HedgeCount: formatNumber2(rowData['lastQtr1HedgeCount']),
      // ...rowData,
    });
  });
  const getOrder = (sortDetail = [], key = '') => {
    let order = false;
    let index = (sortDetail || []).findIndex((d) => d.sortBy === key);
    if (index > -1) {
      order =
        sortDetail[index].sortOrder === 'ASC'
          ? 'ascend'
          : sortDetail[index].sortOrder === 'DESC'
          ? 'descend'
          : false;
    }
    return order;
  };

  const columns = [
    {
      title: 'Symbol',
      dataIndex: 'symbol',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'Symbol'),
      align: 'center',
      key: 'symbol',
      render: (text) => ({
        children: (
          <p
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            style={{
              color: green,
              fontWeight: 700,
              lineHeight: '40px',
              cursor: 'Pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
            onClick={() => {
              let filters = {};
              filters = {
                type: 'SYMBOL'.toLowerCase(),
                subtype: 'INDIVIDUAL_STATISTICAL_REPORT'.toLowerCase(),
                symbols: text,
              };
              history.push(`/search/report/` + queryString.stringify(filters));
            }}
          >
            {text}
          </p>
        ),
      }),
    },
    {
      title: 'Sector',
      dataIndex: 'sector',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'sector'),
      align: 'center',
      key: 'sector',
    },
    {
      title: <span className={styles.NonSortableColumn}>Beginning Volume</span>,
      dataIndex: 'beginPrice',
      key: 'beginPrice',
      align: 'center',
    },
    {
      title: (
        <span className={styles.NonSortableColumn}>
          Price When Vol Increased
        </span>
      ),
      dataIndex: 'startPrice',
      key: 'startPrice',
      align: 'center',
    },
    {
      title: 'Last Sale',
      dataIndex: 'lastSale',
      key: 'lastSale',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastSale'),
      align: 'center',
    },
    {
      title: <span className={styles.NonSortableColumn}>Ending Volume</span>,
      dataIndex: 'endPrice',
      key: 'endPrice',
      align: 'center',
    },
    {
      title: (
        <span className={styles.NonSortableColumn}>Difference in Avg Vol</span>
      ),
      dataIndex: 'latestPeriodChange',
      key: 'latestPeriodChange',
      align: 'center',
    },
    {
      title: <span className={styles.NonSortableColumn}>Latest Vol %</span>,
      dataIndex: 'latestPeriodReturns',
      key: 'latestPeriodReturns',
      align: 'center',
    },
    {
      title: (
        <span className={styles.NonSortableColumn}>
          % Change to Latest Price
        </span>
      ),
      dataIndex: 'latestPercPrice',
      key: 'latestPercPrice',
      align: 'center',
    },
    {
      title: 'Year Begin Price',
      dataIndex: 'year_start_price',
      key: 'year_start_price',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'year_start_price'),
      align: 'center',
    },
    {
      title: (
        <span className={styles.NonSortableColumn}>Price Latest Status</span>
      ),
      dataIndex: 'ytd_increased',
      key: 'ytd_increased',
      align: 'center',
    },
    {
      title: (
        <span className={styles.NonSortableColumn}>Price Past Status</span>
      ),
      dataIndex: 'ytd_past_increased',
      key: 'ytd_past_increased',
      align: 'center',
    },
    {
      title: (
        <span className={styles.NonSortableColumn}>Price Latest Returns %</span>
      ),
      dataIndex: 'latest_returns_perc',
      key: 'latest_returns_perc',
      align: 'center',
    },
    {
      title: 'YTD',
      dataIndex: 'ytd',
      key: 'ytd',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'ytd'),
      align: 'center',
    },
    {
      title: '1 Yr',
      dataIndex: 'oneYrGrowth',
      key: 'oneYrGrowth',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'oneYrGrowth'),
      align: 'center',
    },
    {
      title: '5 Yr',
      dataIndex: 'fiveYrGrowth',
      key: 'fiveYrGrowth',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'fiveYrGrowth'),
      align: 'center',
    },
    {
      title: (
        <span className={styles.NonSortableColumn}>Dow Vol Latest Status</span>
      ),
      dataIndex: 'noOfWeeksLatest',
      key: 'noOfWeeksLatest',
      align: 'center',
    },
    {
      title: `${getLastQtrByIdx(2).split('_')[1]} Shares`,
      dataIndex: 'lastQtr2Shares',
      key: 'lastQtr2Shares',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastQtr2Shares'),
      align: 'center',
    },
    {
      title: `${getLastQtrByIdx(1).split('_')[1]} Shrs`,
      dataIndex: 'lastQtr1Shares',
      key: 'lastQtr1Shares',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastQtr1Shares'),
      align: 'center',
    },
    {
      title: `Shares Chng %`,
      dataIndex: 'lastQtrSharesChange',
      key: 'lastQtrSharesChange',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastQtrSharesChange'),
      align: 'center',
    },
    {
      title: `${getLastQtrByIdx(2).split('_')[1]} Count`,
      dataIndex: 'lastQtr2Count',
      key: 'lastQtr2Count',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastQtr2Count'),
      align: 'center',
    },
    {
      title: `${getLastQtrByIdx(1).split('_')[1]} Count`,
      dataIndex: 'lastQtr1Count',
      key: 'lastQtr1Count',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastQtr1Count'),
      align: 'center',
    },
    {
      title: `Count Chng %`,
      dataIndex: 'lastQtrCountChange',
      key: 'lastQtrCountChange',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastQtrCountChange'),
      align: 'center',
    },
    {
      title: `${getLastQtrByIdx(1).split('_')[1]} Hedge Count`,
      dataIndex: 'lastQtr1HedgeCount',
      key: 'lastQtr1HedgeCount',
      sorter: true,
      sortDirections: ['descend', 'ascend'],
      sortOrder: getOrder(sortDetail, 'lastQtr1HedgeCount'),
      align: 'center',
    },
  ];
  const filteredColumns = columns.filter((col) =>
    visibleColumnsData.some(
      (visibleCol) => visibleCol.key === col.key && visibleCol.visible,
    ),
  );
  useEffect(() => {}, [visibleColumnsData]);

  return (
    <Table
      style={getReportStyles({ reportSubType, queryData, reportType })}
      loading={isLoading}
      scroll={{ y: y }}
      columns={filteredColumns}
      dataSource={rows}
      pagination={false}
      size="small"
      bordered={true}
      rowClassName={styles.tableHeader}
      className={styles.TabularData}
      showSorterTooltip={false}
      onChange={onTableChange}
      id="allPicksId"
    />
  );
};

export default VolTable;
